import React from 'react';

const UrgencyBanner = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-red-700 via-red-600 to-red-800 text-white py-6 md:py-8 shadow-[inset_0_4px_15px_rgba(0,0,0,0.3)] border-y-2 border-red-500">
       {/* Metallic Glare Effect */}
       <div className="absolute top-0 inset-x-0 h-1/2 bg-gradient-to-b from-white/20 to-transparent pointer-events-none"></div>
       <div className="absolute bottom-0 inset-x-0 h-1/4 bg-gradient-to-t from-black/20 to-transparent pointer-events-none"></div>
       
       <div className="container mx-auto px-4 text-center relative z-10 flex flex-row items-center justify-center gap-3">
         <span className="animate-ping relative inline-flex h-3 w-3 sm:h-4 sm:w-4 rounded-full bg-yellow-400 opacity-90 drop-shadow-lg shrink-0"></span>
         <h2 className="text-[17px] min-[375px]:text-xl md:text-3xl font-extrabold tracking-wide drop-shadow-lg text-white">
           সীমিত স্টক! এখনই অর্ডার করুন
         </h2>
       </div>
    </section>
  );
};

export default UrgencyBanner;
